import { ref, computed } from 'vue'
import axios from 'axios'

export function useHelpdesk() {
    const isSubmitting = ref(false)
    const tickets = ref([])
    const error = ref(null)

    // Submit a new ticket
    const submitTicket = async (formData) => {
        isSubmitting.value = true
        error.value = null

        try {
            const response = await axios.post('/api/v1/helpdesk/tickets', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })

            if (response.data.success) {
                // Optionally refresh tickets
                await fetchTickets()
            }

            return response.data
        } catch (err) {
            error.value = err.response?.data?.errors || 'An error occurred'
            throw err
        } finally {
            isSubmitting.value = false
        }
    }

    // Fetch user's tickets
    const fetchTickets = async () => {
        try {
            const response = await axios.get('/api/v1/helpdesk/tickets')
            tickets.value = response.data.tickets
        } catch (err) {
            error.value = 'Failed to load tickets'
            console.error('Error fetching tickets:', err)
        }
    }

    // Load helpdesk widget (if using widget)
    const loadWidget = () => {
        const scriptUrl =
            (typeof process !== 'undefined' && process.env && process.env.MIX_HELPDESK_WIDGET_URL) ||
            (typeof window !== 'undefined' && window.HELPDESK_WIDGET_URL) ||
            null

        if (scriptUrl) {
            const script = document.createElement('script')
            script.src = scriptUrl
            script.async = true
            document.head.appendChild(script)
        }
    }

    // Pre-fill form with user data
    const getUserData = () => {
        // Assuming user data is available in a global store or window object
        return {
            email: window.user?.email || '',
            name: window.user?.name || '',
        }
    }

    return {
        isSubmitting: computed(() => isSubmitting.value),
        tickets: computed(() => tickets.value),
        error: computed(() => error.value),
        submitTicket,
        fetchTickets,
        loadWidget,
        getUserData,
    }
}
